import { render, staticRenderFns } from "./center.vue?vue&type=template&id=53b78852&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&id=53b78852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b78852",
  null
  
)

export default component.exports